import { ReactElement } from 'react';

import SpinIcon from '@/icons/spin';

interface ICircularProgressSpinProps {
	wrapperClassName?: string;
	innerClassName?: string;
}

const CircularProgressSpin = ({
	wrapperClassName = '',
	innerClassName = '',
}: ICircularProgressSpinProps): ReactElement => (
	<div className={`relative aspect-square w-5 rounded-full bg-transparent ${wrapperClassName}`}>
		<div role="status" className={`absolute inset-0 flex items-center justify-center ${innerClassName}`}>
			<SpinIcon className="text-gray-200 dark:text-gray-600 h-8 w-8 animate-spin fill-blue-600" />
		</div>
	</div>
);

export default CircularProgressSpin;
